module.exports = __webpack_public_path__ + "img/logo-red.1a664c3c.png";